/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();

      this.energyLabel = this.section.querySelector('.product-info__energy-label');

      VariantPicker.updateLabelText();

      this.updateAvailability();
      this.updateAddToCartButton();
      this.updateShippingTime();
      this.updateShortDescription(); 
      this.updateProperties(); 
      this.addEventListener('change', this.handleVariantChange.bind(this));
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.getSelectedVariant();

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateWeight();
        this.updateVariantInput();
        this.updateSku();
        this.updateShippingTime();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateShippingTime();
      this.updateShortDescription(); 
      this.updateProperties(); 
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }
      }));
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;
  
      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
  
      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
  
      // Find the shopify-payment-button element
      const paymentButton = this.productForm.querySelector('.shopify-payment-button');
  
      // Update the display property of the payment button
      if (paymentButton) {
          paymentButton.style.display = variantAvailable ? 'block' : 'none';
      }
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    updateShippingTime() {
      if (!this.variant || !this.variant.metafields) return;

      const shippingTimeElement = this.section.querySelector('.shipping_time');
      const shippingElement = this.section.querySelector('.shipping');
      const $status = this.section.querySelector(".shipping-status")

      let shippingTime = this.variant.metafields.custom.variants_fields.lieferzeit;

      if(!shippingTimeElement || !shippingElement) return

      if (shippingTime) {
        shippingElement.innerHTML = shippingTime;
        shippingTimeElement.style.display = 'flex';
        
        if(shippingTime === "Artikel ausverkauft" || shippingTime === "Articolo esaurito" || shippingTime === "Item sold out" || shippingTime === "Article vendu" || shippingTime === "Nicht verfügbar" || shippingTime === "Non disponible" || shippingTime === "Pas disponible" || shippingTime === "Not available") {
            $status.classList.add("sold-out")
        } else {
          $status.classList.remove("sold-out")
        }

        if(shippingTime.includes("5-7 days") || shippingTime.includes("5-7 Tage") || shippingTime.includes("5-7 giorni") || shippingTime.includes("5-7 jours")) {
          $status.classList.add("days")
        } else {
          $status.classList.remove("days")
        } 

        if(shippingTime.includes("2 weeks") || shippingTime.includes("2 Wochen") || shippingTime.includes("2 semaines") || shippingTime.includes("2 settimane")) {
            $status.classList.add("weeks")
        } else {
          $status.classList.remove("weeks")
        }  
        
        if(shippingTime.includes("4 weeks") || shippingTime.includes("4 Wochen") || shippingTime.includes("4 semaines") || shippingTime.includes("4 settimane")) {
            $status.classList.add("fourweeks")
        } else {
          $status.classList.remove("fourweeks")
        } 
        
        if(shippingTime.includes("months") || shippingTime.includes("Monate") || shippingTime.includes("mesi") || shippingTime.includes("mois") || 
            shippingTime.includes("6-8 Wochen") || shippingTime.includes("6-8 weeks") || shippingTime.includes("6-8 semaines") || shippingTime.includes("6-8 settimane") ||
            shippingTime.includes("12 Wochen") || shippingTime.includes("12 weeks") || shippingTime.includes("12 semaines") || shippingTime.includes("12 settimane")) {
            $status.classList.add("months")
        } else {
          $status.classList.remove("months")
        }
      } else {
        shippingTimeElement.style.display = 'none';
      }
    }

    updateProperties() {
      if (!this.variant || !this.variant.metafields) return;

      let properties = this.variant.metafields.custom.properties;
      let variants_fields = this.variant.metafields.custom.variants_fields;

      const propertiesBlock = document.querySelector('.properties .properties_block');
      if(!propertiesBlock) return

      propertiesBlock.innerHTML = '';

      let sortedProperties = [...properties].sort((a, b) => a.pos - b.pos);

      let displayedCategories = new Set();

      sortedProperties.forEach(property => {
          if (variants_fields.hasOwnProperty(property.variable) && property.ausblenden != true) {
            let value = variants_fields[property.variable];

            let isURL = /^(https?:\/\/[^\s]+)$/.test(value);

            let propertyContent = isURL 
                ? `<a href="${value}" target="_blank">Download</a>` 
                : value;

            let categoryContent = '';
            if (!displayedCategories.has(property.kategorie)) {
                categoryContent = `<h3 class="property-title mb-6">${property.kategorie}</h3>`;
                displayedCategories.add(property.kategorie);  
            }

            let content = `
                <div class="properties flex justify-between">
                    ${categoryContent}
                    <div class="flex justify-between flex-wrap">
                        <div class="title">${property.titel}</div>
                        <div class="property">${propertyContent}</div>
                    </div>
                </div>`;

            propertiesBlock.innerHTML += content;
          }
      });
    }

    updateShortDescription() {
      if (!this.variant || !this.variant.metafields) return;

      const kurzbeschreibungElement = this.section.querySelector('.shortdescription__text');
      const toggleButton = this.section.querySelector('.shortdescription__toggle-btn');

      if (!kurzbeschreibungElement || !toggleButton) return;
    
      let kurzbeschreibung = this.variant && this.variant.metafields.custom && this.variant.metafields.custom  && this.variant.metafields.custom.variants_fields.shortdescription;
      if (!kurzbeschreibung) {
        if (this.product && Array.isArray(this.product.variants)) {
          for (let variant of this.product.variants) {
            if (
              variant.metafields &&
              variant.metafields.custom &&
              variant.metafields.custom.variants_fields &&
              variant.metafields.custom.variants_fields.shortdescription
            ) {
              kurzbeschreibung = variant.metafields.custom.variants_fields.shortdescription;
              break;
            }
          }
        } 
      }
    
      kurzbeschreibungElement.innerHTML = kurzbeschreibung || '';
    
      const maxLength = 100; 
      const originalText = kurzbeschreibungElement.textContent.trim();
      
      if (originalText.length > maxLength) {
        const truncatedText = originalText.substring(0, maxLength) + '...';
        kurzbeschreibungElement.textContent = truncatedText;
    
        toggleButton.addEventListener('click', function() {
          const isExpanded = toggleButton.getAttribute('data-action') === 'expand';
          
          if (isExpanded) {
            kurzbeschreibungElement.textContent = originalText;
            toggleButton.textContent = 'Weniger anzeigen';
            toggleButton.setAttribute('data-action', 'collapse');
          } else {
            kurzbeschreibungElement.textContent = truncatedText;
            toggleButton.textContent = 'Mehr anzeigen';
            toggleButton.setAttribute('data-action', 'expand');
          }
        });
    
        toggleButton.style.display = 'block'; 
      } else {
        toggleButton.style.display = 'none'; 
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;
      const selectedOptions = this.getSelectedOptions();

      if (!this.variant) {
        currVariant = { options: selectedOptions };
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === selectedOptions[i] || selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt = null) {
      if(evt != null) {
        const selector = evt.target.closest('.option-selector');
        if (selector.dataset.selectorType === 'dropdown') return;
      }
    
      const optionSelectors = document.querySelectorAll('.option-selector__btns');

      optionSelectors.forEach(selector => {
        const checkedElement = selector.querySelector('.opt-btn:checked');
        const labelValueSpan = selector.previousElementSibling.querySelector('.option-selector__label-value.js-text');
        
        if (checkedElement) {
          labelValueSpan.textContent = checkedElement.value;
        }
      });
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was .price');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        if (priceWasEl)
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
      
      const shippingTimeElement = document.querySelector('.shipping_time');
      const labelElement = document.querySelector('.product-price .product-info__block');

      if(this.variant) {
        shippingTimeElement.classList.remove('hidden');
        labelElement.classList.remove('hidden');
      } else {
        shippingTimeElement.classList.add('hidden');
        labelElement.classList.add('hidden');
      }
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else if (selector.dataset.selectorType === 'listed') {
          const selectedRadio = selector.querySelector('input[type="radio"]:checked');
          if (selectedRadio) {
              selectedOptions.push(selectedRadio.value.trim());
          } else {
              selectedOptions.push(null); 
          }
        } else {
          selectedOptions.push(selector.querySelector('input:checked').value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');

      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
        const selectedOptions = this.getSelectedOptions();
        const variant = this.data.product.variants.find((v) => v.options.every((val, index) => val === selectedOptions[index]));
     
        if (variant) {
            const formattedVariant = this.data.formatted[variant.id];

            if (formattedVariant && formattedVariant.metafields) {
                variant.metafields = formattedVariant.metafields;
            }
        }
        return variant;
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
